<div class="options" [style]="style" fxLayout="column" *ngIf="options">
  <form>
    <div fxLayout="column">
      <mat-slider [min]="0" [max]="20" [step]="1" [thumbLabel]="true"
                  [(ngModel)]="options.slow" name="slow"
                  (change)="onChange()"></mat-slider>
      <mat-checkbox [(ngModel)]="options.remote" name="remote" (change)="onChange()">remote</mat-checkbox>
    </div>
  </form>
</div>
